import { getRejectionReasonByCode } from '@/apps/payin/payins/services/rejectionReasons';
import { payinStatus } from '@/apps/payin/payins/constants/payinStatus';
import { payinsResource } from '@/commons/resources/payins';
import { refundResource } from '@/commons/resources/refund';
import moment from '@transfeeradev/moment';
import { realToCents } from '@/commons/formatters/currency';

export async function listPayins({
  page,
  pageCursor,
  pageSize,
  search,
  statuses = {},
  paymentTypes = {},
  startDate,
  endDate
}) {
  const status__in = Object.entries(statuses)
    .filter(([, value]) => value)
    .map(([key]) => key);

  const payment_type__in = Object.entries(paymentTypes)
    .filter(([, value]) => value)
    .map(([key]) => key);

  const oneMonthDateFilterLimit = moment('2024-01-01');
  const isEndMonthBeforeLimit = moment(endDate).isBefore(oneMonthDateFilterLimit);
  const isStartMonthBeforeLimit = moment(startDate).isBefore(oneMonthDateFilterLimit);

  if (isEndMonthBeforeLimit) {
    return {
      payins: [],
      metadata: { pagination: { itemsPerPage: 10, totalItems: null } },
      isEndDateOutOfBounds: true
    };
  }

  const pagination = pageCursor ? { page_cursor: pageCursor, page_size: pageSize } : { page, page_size: pageSize };

  const response = await payinsResource.get({
    ...pagination,
    status__in,
    payment_type__in,
    search,
    created_at__gte: isStartMonthBeforeLimit ? moment('2024-01-01').toISOString() : moment(startDate).toISOString(),
    created_at__lte: moment(endDate).toISOString()
  });
  return {
    payins: response.items.map(item => {
      const status =
        {
          [payinStatus.CANCELED_BY_USER]: 'canceled',
          [payinStatus.CANCELED_BY_PSP]: 'canceled'
        }[item.status] || item.status;
      return {
        ...item,
        status
      };
    }),
    metadata: response.metadata,
    isEndDateOutOfBounds: false
  };
}

export async function getPayinById(id) {
  const response = await payinsResource.getById(id);
  const isCanceled =
    response.status === payinStatus.CANCELED_BY_USER || response.status === payinStatus.CANCELED_BY_PSP;
  const isRefunded = response.status === payinStatus.PARTIALLY_REFUNDED;

  return {
    ...response,
    status: isCanceled ? 'canceled' : isRefunded ? 'refunded' : response.status,
    rejectionReason: getRejectionReasonByCode(response.details?.rejection_reason)
  };
}

export async function listRefunds(id) {
  const response = await refundResource.getRefundsByPayinId(id);
  return {
    refunds: response.items.map(item => item),
    metadata: response.metadata
  };
}

export async function refund(id, amount) {
  await refundResource.refund(id, realToCents(amount));
}

export async function createReport({ createdAtGte, createdAtLte, statuses, paymentTypes, search }) {
  const status__in = Object.entries(statuses)
    .filter(([, value]) => value)
    .map(([key]) => key);

  const payment_type__in = Object.entries(paymentTypes)
    .filter(([, value]) => value)
    .map(([key]) => key);

  const res = await payinsResource.exportCSV({
    created_at__gte: moment(createdAtGte).toISOString(),
    created_at__lte: moment(createdAtLte).toISOString(),
    status__in,
    payment_type__in,
    search
  });

  return res.id;
}

export function getReportById(id) {
  return payinsResource.getReportById(id);
}
